// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Ue8w3","spinnerItem":"Spinner_spinnerItem__PXbF5"};